import {Injectable} from '@angular/core';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import {Http, Headers} from '@angular/http';
import {GlobalService} from "./global.config";
import {User,Stop,Mileage} from "../objects/real-time";
import {Events } from 'ionic-angular';

@Injectable()
export class HistoricalService {

    currentuser:User;
dns:string;
    constructor(private _http: Http,private globalService : GlobalService,public events: Events) {
        this.currentuser= JSON.parse(localStorage.getItem('currentuser'));
      this.events.subscribe('dns', (dns) => {
     //console.log(path);
     if (dns){
        this.dns = dns;
     }
   });
        console.log(this.dns);
    }
   
    getMileageDetails(deviceId: number, dateInterval: any): Observable<any> {
        let headers = new Headers({'Accept': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.post(this.dns + 'mileage/details/' + deviceId, dateInterval, {headers: headers}).map(res => res.json());
    }
    getAllMileages(deviceId: number, dateInterval: any): Observable<Mileage[]> {
        let headers = new Headers({'Accept': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.post(this.dns + 'mileage/' + deviceId, dateInterval, {headers: headers}).map(res => res.json());
    }
    getAllGroups(): Observable<any[]> {
        let headers = new Headers({'Accept': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.get(this.dns + 'groupes/minify', {headers: headers}).map(res => res.json());
    }

    getAllPaths(deviceId: number, dateInterval: any): Observable<any[]> {
        let headers = new Headers({'Accept': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.post(this.dns + 'paths/' + deviceId, dateInterval, {headers: headers}).map(res => res.json());
    }
    getAllStops(deviceId: number, dateInterval: any): Observable<Stop[]> {
        let headers = new Headers({'Accept': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.post(this.dns + 'stops/' + deviceId, dateInterval, {headers:headers}).map(res => res.json());
    }


    getCurrentPath(deviceId: number): Observable<any> {
        let headers = new Headers({'Accept': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.post(this.dns + 'paths/currentPath/' + deviceId,null,  {headers: headers}).map(res => res.json());
    }

    getPathDetails(deviceId: number, dateInterval: any): Observable<any> {
        let headers = new Headers({'Accept': 'application/json'});
        headers.append('Authorization', this.currentuser.token);
        return this._http.post(this.dns + 'paths/details/' + deviceId, dateInterval, {headers: headers}).map(res => res.json());
    }

}



// WEBPACK FOOTER //
// ./src/providers/historical.service.ts